// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ChevronRightIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ChevronRightIcon" ref={forwardedRef} {...props}>
      <path d="M7.636 16.364 14 10 7.636 3.636 6.579 4.693l5.3 5.307-5.304 5.303z" />
    </SvgIcon>
  );
});

/**
 * Indicates the ability to navigate to the next step, view overflow items to the right, expand the tree
 * @public
 */
export const ChevronRightIcon = /* @__PURE__ */ Object.assign(
  ChevronRightIconComponent,
  { displayName: 'ChevronRightIcon' },
);
